const data = [
  { 
    id: 1, 
    name: "Geral", 
    permissions: ["*"] 
  },
  { 
    id: 2, 
    name: "Site", 
    permissions: [
      {
        path: "Site",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "Faq",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "GeneralMeeting",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "Blog",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "BlogCategory",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "Manager",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "Client",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "DynamicInfo",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
    ] 
  },
  { 
    id: 3, 
    name: "RVC",
    permissions: [
      {
        path: "Manager",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "Document",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "Client",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "District",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "DynamicText",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "User",
        method: "GET,PATCH",
        permissions: ["access"]
      },
    ] 
  },
  { 
    id: 4, 
    name: "RVC + Site",
    permissions: [
      {
        path: "Manager",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "Site",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "Document",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "Client",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "District",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "DynamicText",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "User",
        method: "GET,PATCH",
        permissions: ["access"]
      },
      {
        path: "Faq",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "GeneralMeeting",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "Blog",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "BlogCategory",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "DynamicInfo",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
    ] 
  },
  { 
    id: 5, 
    name: "Contabilidade",
    permissions: [
      {
        path: "Manager",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "Event",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
    ] 
  },
  { 
    id: 6, 
    name: "Operador",
    permissions: [
      {
        path: "Manager",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "Event",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["find-details", "access"]
      },
      {
        path: "CreditorsRequests",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "DynamicText",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "User",
        method: "GET,PATCH",
        permissions: ["access"]
      },
    ] 
  },
];

export default [...data];
